// extracted by mini-css-extract-plugin
module.exports = {"overview":"Overview_overview__1mUxe","column":"Overview_column__18Wdu"};